module.exports = __webpack_public_path__ + "img/mode1-1.8a049f80.png";